module.exports = __webpack_public_path__ + "img/active-list7.df0c3a9e.png";